import type { EditionCapabilities } from './api-types.js';

/**
 * Two editions, one code base (ADR-0019, ADR-0023, 06 §28.2). Every service turns `OPPY_EDITION` into these flags
 * when it reads its settings, from this one table; the rest of the code asks for a capability, never for an edition.
 */
export type Edition = 'bireysel' | 'kurumsal';

export const EDITION_CAPABILITIES: Record<Edition, EditionCapabilities> = {
  bireysel: {
    publicSignup: true,
    passwordLogin: true,
    directoryLogin: false,
    breakGlass: false,
    directoryTeams: false,
    licensing: false,
    singleCompany: false,
    // Phase 16c: subscriptions, invoices and the payments page; whether "Pro'ya geç" sells is the provider's (meta)
    billing: true,
    organization: false,
    invites: false,
    codeExperience: false,
    microsoft365: false,
    plans: true,
    phoneApp: false,
    ownModelProviders: false,
  },
  kurumsal: {
    publicSignup: false,
    passwordLogin: false,
    directoryLogin: true,
    breakGlass: true,
    directoryTeams: true,
    licensing: true,
    singleCompany: true,
    billing: false,
    organization: true,
    invites: false,
    codeExperience: true,
    microsoft365: true,
    plans: false,
    phoneApp: true,
    ownModelProviders: true,
  },
};

export function capabilitiesOf(edition: Edition): EditionCapabilities {
  return { ...EDITION_CAPABILITIES[edition] };
}

/**
 * Integration tests of the shared features (D-257): every shared feature on, people sign up by e-mail, no plans. Not
 * an edition: an edition is a row of the table above, and its own tests use that row.
 */
export const SHARED_TEST_CAPABILITIES: EditionCapabilities = {
  publicSignup: true,
  passwordLogin: true,
  directoryLogin: false,
  breakGlass: false,
  directoryTeams: false,
  licensing: false,
  singleCompany: false,
  billing: false,
  organization: true,
  invites: true,
  codeExperience: true,
  microsoft365: true,
  plans: false,
  phoneApp: false,
  ownModelProviders: true,
};
